import HeaderMessage from './HeaderMessage';

export default HeaderMessage;
